const PATH = 'fe.components.trainings.view.invitation_banner';

const messages = {
  title: {
    key: `${PATH}.title`,
    defaultValue: 'You have been invited to attend this training.'
  },
  subtitle: {
    key: `${PATH}.subtitle`,
    defaultValue:
      'To confirm your registration, please accept or decline this invitation.'
  },
  accept: {
    key: `${PATH}.accept`,
    defaultValue: 'Accept'
  },
  decline: {
    key: `${PATH}.decline`,
    defaultValue: 'Decline'
  },
  error: {
    key: `${PATH}.error`,
    defaultValue:
      'Please refresh the page. If you still see this message, please'
  },
  errorLink: {
    key: `${PATH}.error_link`,
    defaultValue: 'contact us.'
  },
  modal: {
    title: {
      key: `${PATH}.modal.title`,
      defaultValue: 'Are you sure you want to decline this training?'
    },
    confirm: {
      key: `${PATH}.modal.confirm`,
      defaultValue: 'Yes, I will not attend'
    },
    cancel: {
      key: `${PATH}.modal.cancel`,
      defaultValue: 'Cancel'
    }
  }
};

export default messages;
